import axios from "./request"

export default {
  async create(data) {
    return (await axios.post('/companies', data)).data
  }
}
